import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import i18n from '../../../../../i18n';
import '../../../../../styles/components/banner-hero.scss';
import InteractiveGrid from './Interactivegrid';

const bannerCity = process.env.PUBLIC_URL + '/assets/images/banner-city.jpg';
const bannerCar = process.env.PUBLIC_URL + '/assets/images/banner-car1.jpg';
const bannerMixedscrap = process.env.PUBLIC_URL + '/assets/images/banner-mixedscrap.jpg';

const TICKER_ITEMS = [
    { label: i18n.t('copper_price_today') || 'Copper price today', color: '#2e9e5b' },
    { label: i18n.t('iron_price_today') || 'Iron price today', color: '#ffffff' },
    { label: i18n.t('aluminum_price_today') || 'Aluminum price today', color: '#0c8da2' },
    { label: i18n.t('gold_price_today') || 'Gold price today', color: '#bfc531' },
    { label: i18n.t('silver_price_today') || 'Silver price today', color: '#9ca3af' },
];

const CATEGORY_CARDS = [
    {
        title: i18n.t('real_estate') || 'Real Estate',
        description:
            i18n.t('real_estate_banner_desc'),        // featured: true,
        link: '/auctions?cat=real_estate',
        bgImage: bannerCity,
    },
    {
        title: i18n.t('vehicles') || 'Vehicles',
        description:
            i18n.t('vehicles_banner_desc') ||
            'Find quality vehicles through competitive bidding with verified listings and transparent pricing',
        featured: false,
        link: '/auctions?cat=vehicles',
        bgImage: bannerCar,
    },
    {
        title: i18n.t('mixed_scrap') || 'Mixed Scrap',
        description:
            i18n.t('mixed_scrap_banner_desc') ||
            'Industrial and commercial equipment auctions with detailed specifications and inspection reports',
        featured: false,
        link: '/auctions?cat=equipment',
        bgImage: bannerMixedscrap,
    },
];

class BannerNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeCard: 0,
            prevCard: null,
            isTransitioning: false,
        };
    }

    componentDidMount() {
        // ADD THIS — reads your localStorage key and sets dir on <html>
        const lng = localStorage.getItem('I18N_LANGUAGE');
        document.documentElement.setAttribute('dir', lng === 'ar' ? 'rtl' : 'ltr');
        document.documentElement.setAttribute('lang', lng || 'en');

        CATEGORY_CARDS.forEach((card) => {
            const img = new Image();
            img.src = card.bgImage;
        });
        this.startAutoplay();
    }

    componentWillUnmount() {
        this.stopAutoplay();
        if (this.transitionTimer) clearTimeout(this.transitionTimer);
    }

    startAutoplay = () => {
        this.stopAutoplay();
        this.cardInterval = setInterval(() => {
            this.goToCard((this.state.activeCard + 1) % CATEGORY_CARDS.length);
        }, 5000);
    };

    stopAutoplay = () => {
        if (this.cardInterval) clearInterval(this.cardInterval);
    };

    goToCard = (index) => {
        if (index === this.state.activeCard) return;
        this.setState({
            prevCard: this.state.activeCard,
            activeCard: index,
            isTransitioning: true,
        });
        if (this.transitionTimer) clearTimeout(this.transitionTimer);
        this.transitionTimer = setTimeout(() => {
            this.setState({ isTransitioning: false, prevCard: null });
        }, 800);
    };

    handleDotClick = (index) => {
        this.stopAutoplay();
        this.goToCard(index);
        this.startAutoplay();
    };

    render() {
        const { activeCard, prevCard, isTransitioning } = this.state;
        const card = CATEGORY_CARDS[activeCard];

        return (
            <section className="mzb-hero">
                {/* ── Background gradient ── */}
                <div className="mzb-hero__bg-gradient" />

                {/* ── Rotating background images ── */}
                <div className="mzb-hero__bg-images">
                    {CATEGORY_CARDS.map((item, index) => (
                        <div
                            key={index}
                            className={`mzb-hero__bg-slide ${index === activeCard ? 'mzb-hero__bg-slide--active' : ''
                                } ${index === prevCard && isTransitioning
                                    ? 'mzb-hero__bg-slide--exiting'
                                    : ''
                                }`}
                            style={{ backgroundImage: `url(${item.bgImage})` }}
                        />
                    ))}
                </div>

                <div className="mzb-hero__bg-overlay" />

                {/* ── Interactive dot grid — replaces static SquareGrid ── */}
                <div className="mzb-hero__grid-canvas-wrap">
                    <InteractiveGrid />
                </div>

                {/* ── Content ── */}
                <div className="mzb-hero__content">
                    <div className="container">
                        <div className="mzb-hero__layout container as-slider-outer">

                            {/* ── Left — headline ── */}
                            <div className="bidd_hidden_sm">
                                <div className="mzb-hero__left">
                                    <h1 className="mzb-hero__heading">
                                        <span className="mzb-hero__heading-main">
                                            {i18n.t('leaders') || 'Leaders'}
                                        </span>
                                        <span className="mzb-hero__heading-sub">
                                            {i18n.t('in_smart_auctions') || 'in Smart Auctions'}
                                        </span>
                                    </h1>

                                    <p className="mzb-hero__desc">
                                        {i18n.t('banner_description') ||
                                            'Mzadcom stands at the forefront of smart auctions, redefining excellence through innovation, transparency, and trust'}
                                    </p>

                                    <Link to="/about" className="mzb-hero__cta">
                                        {i18n.t('why_mzadcom')}
                                    </Link>
                                </div>
                            </div>

                            {/* ── Right — glass card ── */}
                            <div className="mzb-hero__right">
                                <div className="mzb-hero__card" key={activeCard}>
                                    {card.featured && (
                                        <Star size={22} className="mzb-hero__card-star" />
                                    )}
                                    <h3 className="mzb-hero__card-title">{card.title}</h3>
                                    <p className="mzb-hero__card-desc">{card.description}</p>
                                    <Link to={card.link} className="mzb-hero__card-btn">
                                        {i18n.t('more_details') || 'More details'}
                                    </Link>
                                </div>

                                {/* Card dots */}
                                <div className="mzb-hero__card-dots">
                                    {CATEGORY_CARDS.map((_, i) => (
                                        <button
                                            key={i}
                                            className={`mzb-hero__card-dot ${i === activeCard ? 'mzb-hero__card-dot--active' : ''
                                                }`}
                                            onClick={() => this.handleDotClick(i)}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default BannerNew;